var _g, _g2, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 101,
    viewBox: "0 0 416 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2272_184)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.13086,
    y: 0.437622,
    width: 414.032,
    height: 90.9961,
    rx: 30.332,
    transform: "rotate(0.441137 1.13086 0.437622)",
    fill: "#FFDF6D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2272_184)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.16113,
    y: 5.03442,
    width: 401.9,
    height: 75.8301,
    rx: 30.332,
    transform: "rotate(0.441137 7.16113 5.03442)",
    fill: "#FFCF25"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1355 25.8107C19.2042 16.9005 26.4829 9.73298 35.3931 9.80159L380.75 12.4606C389.66 12.5292 396.827 19.8076 396.758 28.7174C396.686 38.045 388.798 45.3808 379.492 44.7501C344.766 42.3971 264.623 37.3633 208.45 36.917C151.875 36.4675 71.0647 40.2857 36.1516 42.1084C26.8365 42.5947 19.0637 35.1381 19.1355 25.8107Z",
    fill: "#FFD84C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4335 13.2768C44.3112 16.7248 41.7254 23.6251 37.3544 27.2732C32.9834 30.9213 25.7318 32.2313 22.8541 28.7833C19.9764 25.3353 21.8027 19.0689 26.9332 14.7869C32.0638 10.5049 38.5558 9.82883 41.4335 13.2768Z",
    fill: "#FFE588"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2272_184",
    x: 0.740234,
    y: 0.747314,
    width: 414.102,
    height: 99.6282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.06641
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.835982 0 0 0 0 0.251667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2272_184"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2272_184",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2272_184",
    x: 6.8418,
    y: 5.29932,
    width: 401.942,
    height: 84.4587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.06641
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.929167 0 0 0 0 0.72458 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2272_184"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2272_184",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkayBtn);
export default __webpack_public_path__ + "static/media/okay-btn.19eef259252616043da56d92be257e3f.svg";
export { ForwardRef as ReactComponent };